import { render, staticRenderFns } from "./alt-demographics.vue?vue&type=template&id=25add289&scoped=true&"
import script from "./alt-demographics.vue?vue&type=script&lang=js&"
export * from "./alt-demographics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25add289",
  null
  
)

export default component.exports